import { render } from "./Form2.vue?vue&type=template&id=14c16d19&scoped=true"
import script from "./Form2.vue?vue&type=script&lang=js"
export * from "./Form2.vue?vue&type=script&lang=js"

import "./Form2.vue?vue&type=style&index=0&id=14c16d19&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-14c16d19"

export default script